"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  ui: true,
  uiMerge: true,
  getClassActive: true,
  browserName: true,
  useResizeDetector: true,
  ellipsis: true,
  getBestPosition: true,
  checkOverflow: true,
  makeMq: true,
  visualSettings: true,
  statusModifiers: true,
  statusBgColors: true,
  statusHexColors: true,
  contrastColor: true,
  isTextLight: true,
  rgba2hex: true,
  styleObjectToString: true,
  Scrollbar: true,
  OverlayScroll: true,
  Portal: true,
  Tooltip: true,
  CheckboxWrapper: true,
  FlexScrollbarWrapper: true,
  useMediaQuery: true,
  uiTest: true
};
Object.defineProperty(exports, "useResizeDetector", {
  enumerable: true,
  get: function get() {
    return _reactResizeDetector.useResizeDetector;
  }
});
Object.defineProperty(exports, "ellipsis", {
  enumerable: true,
  get: function get() {
    return _smartTruncate.default;
  }
});
Object.defineProperty(exports, "getBestPosition", {
  enumerable: true,
  get: function get() {
    return _get_best_position.default;
  }
});
Object.defineProperty(exports, "checkOverflow", {
  enumerable: true,
  get: function get() {
    return _check_overflow.default;
  }
});
Object.defineProperty(exports, "makeMq", {
  enumerable: true,
  get: function get() {
    return _make_mq.default;
  }
});
Object.defineProperty(exports, "visualSettings", {
  enumerable: true,
  get: function get() {
    return _ui_general_settings.visualSettings;
  }
});
Object.defineProperty(exports, "statusModifiers", {
  enumerable: true,
  get: function get() {
    return _ui_general_settings.statusModifiers;
  }
});
Object.defineProperty(exports, "statusBgColors", {
  enumerable: true,
  get: function get() {
    return _ui_general_settings.statusBgColors;
  }
});
Object.defineProperty(exports, "statusHexColors", {
  enumerable: true,
  get: function get() {
    return _ui_general_settings.statusHexColors;
  }
});
Object.defineProperty(exports, "contrastColor", {
  enumerable: true,
  get: function get() {
    return _contrast_color.contrastColor;
  }
});
Object.defineProperty(exports, "isTextLight", {
  enumerable: true,
  get: function get() {
    return _contrast_color.isTextLight;
  }
});
Object.defineProperty(exports, "rgba2hex", {
  enumerable: true,
  get: function get() {
    return _contrast_color.rgba2hex;
  }
});
Object.defineProperty(exports, "styleObjectToString", {
  enumerable: true,
  get: function get() {
    return _style_object_to_string.styleObjectToString;
  }
});
Object.defineProperty(exports, "Scrollbar", {
  enumerable: true,
  get: function get() {
    return _scrollbar.default;
  }
});
Object.defineProperty(exports, "OverlayScroll", {
  enumerable: true,
  get: function get() {
    return _scrollbar.OverlayScroll;
  }
});
Object.defineProperty(exports, "Portal", {
  enumerable: true,
  get: function get() {
    return _portal.default;
  }
});
Object.defineProperty(exports, "Tooltip", {
  enumerable: true,
  get: function get() {
    return _tooltip.default;
  }
});
Object.defineProperty(exports, "CheckboxWrapper", {
  enumerable: true,
  get: function get() {
    return _checkbox_wrapper.default;
  }
});
Object.defineProperty(exports, "FlexScrollbarWrapper", {
  enumerable: true,
  get: function get() {
    return _flex_scrollbar_wrapper.default;
  }
});
Object.defineProperty(exports, "useMediaQuery", {
  enumerable: true,
  get: function get() {
    return _use_mq.default;
  }
});
Object.defineProperty(exports, "uiTest", {
  enumerable: true,
  get: function get() {
    return _ui_test.default;
  }
});
exports.browserName = exports.getClassActive = exports.uiMerge = exports.ui = void 0;

var _lodash = require("lodash");

var _detectBrowser = require("detect-browser");

var _reactResizeDetector = require("react-resize-detector");

var _smartTruncate = _interopRequireDefault(require("smart-truncate"));

var _block_name = require("./from-dictionary/block_name");

Object.keys(_block_name).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _block_name[key];
    }
  });
});

var _rs_dropdown_menu = require("./react_select/rs_dropdown_menu");

Object.keys(_rs_dropdown_menu).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _rs_dropdown_menu[key];
    }
  });
});

var _rs_select = require("./react_select/rs_select");

Object.keys(_rs_select).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _rs_select[key];
    }
  });
});

var _rs_color_picker = require("./react_select/rs_color_picker");

Object.keys(_rs_color_picker).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _rs_color_picker[key];
    }
  });
});

var _color = require("./from-dictionary/color");

Object.keys(_color).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _color[key];
    }
  });
});

var _z = require("./from-dictionary/z");

Object.keys(_z).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _z[key];
    }
  });
});

var _get_best_position = _interopRequireDefault(require("./ui/get_best_position"));

var _check_overflow = _interopRequireDefault(require("./ui/check_overflow"));

var _make_mq = _interopRequireDefault(require("./ui/make_mq"));

var _ui_general_settings = require("./ui/ui_general_settings");

var _contrast_color = require("./utils/contrast_color");

var _style_object_to_string = require("./utils/style_object_to_string");

var _scrollbar = _interopRequireWildcard(require("./react_components/scrollbar"));

var _portal = _interopRequireDefault(require("./react_components/portal"));

var _tooltip = _interopRequireDefault(require("./react_components/tooltip"));

var _checkbox_wrapper = _interopRequireDefault(require("./react_wrappers/checkbox_wrapper"));

var _flex_scrollbar_wrapper = _interopRequireDefault(require("./react_wrappers/flex_scrollbar_wrapper"));

var _use_mq = _interopRequireDefault(require("./react_hooks/use_mq"));

var _ui_test = _interopRequireDefault(require("./ui/ui_test"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

// import { $ui } from './ui/ui_names';
// import getBlock from './ui/get_block';
var _classNameWrapper = function _classNameWrapper(value) {
  return {
    className: value
  };
};

var _noWrapper = function _noWrapper(value) {
  return value;
};

var _uiGeneric = function _uiGeneric(wrapper, blocksElements) {
  if ((0, _lodash.isFunction)(blocksElements)) {
    return wrapper(blocksElements(_templateObject()));
  }

  return wrapper(Array.isArray(blocksElements) ? blocksElements.join(' ') : blocksElements);
};

var ui = (0, _lodash.partial)(_uiGeneric, _classNameWrapper);
exports.ui = ui;
var uiMerge = (0, _lodash.partial)(_uiGeneric, _noWrapper);
exports.uiMerge = uiMerge;

// // Abstract Library
// export const uiA = getBlock($ui.A);
// // Forms
// export const uiForm = getBlock($ui.Form);
// export const uiFormRow = getBlock($ui.FormRow);
// // Table
// export const uiTable = getBlock($ui.Table);
// // Containers
// export const uiPanel = getBlock($ui.Panel);
// export const uiCard = getBlock($ui.Card);
// export const uiWrapperScroll = getBlock($ui.WrapperScroll);
// export const uiInfo = getBlock($ui.Info);
// // Buttons & controls
// export const uiButton = getBlock($ui.Button);
// export const uiButtonSwitch = getBlock($ui.ButtonSwitch);
// export const uiCheckbox = getBlock($ui.Checkbox);
// export const uiCalendar = getBlock($ui.Calendar);
// // Inputs
// export const uiInputCollapse = getBlock($ui.InputCollapse);
// export const uiCollapser = getBlock($ui.Collapser);
// export const uiInputText = getBlock($ui.InputText);
// export const uiSelect = getBlock($ui.Select);
// export const uiInputGroup = getBlock($ui.InputGroup);
// // Menus
// export const uiMenuDropdown = getBlock($ui.MenuDropdown);
// export const uiMenuFolder = getBlock($ui.MenuFolder);
// // Others
// export const uiVisual = getBlock($ui.Visual);
// export const uiShowOnHover = getBlock($ui.ShowOnHover);
// export const uiFocus = getBlock($ui.Focus);
// export const uiIconStack = getBlock($ui.IconStack);
// export const uiIconSvg = getBlock($ui.IconSvg);
// export const uiBadge = getBlock($ui.Badge);
// export const uiAlert = getBlock($ui.Alert);
// export const uiLoader = getBlock($ui.Loader);
// export const uiAutosizeInput = getBlock($ui.AutosizeInput);
var getClassActive = function getClassActive() {
  for (var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++) {
    params[_key] = arguments[_key];
  }

  var classFragment = params[0],
      statement = params[1];

  if (typeof classFragment !== 'string') {
    statement = classFragment;
    classFragment = '';
  }

  return statement ? "".concat(classFragment, "active") : '';
}; // export { uiGp } from './ui/ui_names';


exports.getClassActive = getClassActive;

var _detect = (0, _detectBrowser.detect)(),
    browserName = _detect.name;

exports.browserName = browserName;